import { IconTime } from '@flixbus/honeycomb-icons-react';

import { CREATE_BREAKDOWN_FLOW_TEXT } from 'pages/WorkAssignments/components/CreateBreakdownFlow/texts';
import { formatSummaryDateTime } from 'utils/datetime/fnsTimeFormatter';

const LABELS = CREATE_BREAKDOWN_FLOW_TEXT.summary.rowLabels;

/**
 * Build the "Post-incident driving" rows from an accepted breakdown.
 * The GraphQL type carries `postIncidentDrivingAssignments`
 * (WorkAssignmentDetailsResponseV2). We surface the start timestamp of the
 * first sequence when it is present.
 *
 * @param {object} breakdown
 * @returns {import('common/BreakdownDetails').BreakdownDetailsRow[]}
 */
export const derivePostIncidentDrivingRowsFromBreakdown = (breakdown) => {
	const firstSequence = breakdown?.postIncidentDrivingAssignments?.workAssignmentSequences?.[0];
	if (!firstSequence?.fromTimestamp) return [];

	return [
		{
			label: LABELS.start,
			value: formatSummaryDateTime(firstSequence.fromTimestamp),
			icon: IconTime,
		},
	];
};
